const Theme = {
  logo_image_url: 'lavienocturneaquebec.png',
  header_full_height: true,

  card_background_color: '#000000',

  token_url: 'lavienocturneaquebec.png',
  token_width: 110,
  token_margin_top: -16,
  token_hidden_tokenIds: [0],

  number_size: 26,
  number_font: `'Comfortaa', sans-serif`,
  number_color: '#38a9d7',
  number_weight: 400,
  number_hidden_tokenIds: [0],

  button_no_border: true,
  button_color: '#38a9d7',
  button_hover_color: '#216581',
  button_hover_text_color: 'white',
  button_outlined_color: '#216581',
  button_outlined_text_color: 'white',
  button_outlined_hover_color: '#38a9d7',
  button_outlined_hover_text_color: 'white',
  button_radius: 50,
  button_padding: '14px 18px',
  button_text_lineheight: 22,
  button_text_weight: 700,

  lock_background_color: '#89959f',

  text_font: `'Questrial', sans-serif`,
  text_color: 'white',
  text_size: 16,
  text_lineheight: 23,

  popup_text_color: 'black',

  title_font: `'Comfortaa', sans-serif`,
  title_color: 'white',
  title_size: 27,
  title_lineheight: 32,
  title_letter_spacing: 0,
  title_weight: 400,

  legend_size: 14,
  legend_lineheight: 20,

  footer_text_color: '#89959f',
  footer_border_color: '#89959f',
}

export default Theme
